/** @format */

import React, { useEffect, useState } from "react";
import { apiUsers } from "../api";
import ImagenLogin from "../assets/img/ImagenLogin.png";
import { useParams } from "react-router";
import { Loader } from "../util/loader";
import { getAlert } from "../util/alert";
import Constantes from "../util/Constantes";

export const RecoverPassword = () => {
  const [Loading, setloading] = useState(false);
  const [cambioContraseniaValue, setCambioContraseniaValue] = useState({});
  const [tokenValid, setTokenValid] = useState(false);
  const [userResponse, setUserResponse] = useState({});
  const [statusChage, setStatusChage] = useState({});
  const [alertMessage, setMessage] = useState("Login UPN");
  let { id } = useParams();
  const handleInputChange = (event) => {
    setCambioContraseniaValue({
      ...cambioContraseniaValue,
      [event.target.name]: event.target.value,
    });
  };

  const handleClickSaveNewPassword = async () => {
    setloading(true);
    /*
        public int id_usuario { get; set; }
        public string usuario { get; set; }
        public string contraseniaAntigua { get; set; }
        public string contraseniaNueva { get; set; }
        public string verificadorContrasenia { get; set; }
         */
    const userPassword = {
      id_usuario: userResponse.apoderado_id,
      usuario: userResponse.usuario,
      confirmarContraseniaNueva:
        cambioContraseniaValue.confirmarContraseniaNueva,
      contraseniaNueva: cambioContraseniaValue.contraseniaNueva,
    };
    if (
      cambioContraseniaValue.contraseniaNueva ==
      cambioContraseniaValue.confirmarContraseniaNueva
    ) {
      const promise = apiUsers.updateAttorney(userPassword, alertMessage);
      promise.then((res) => {
        if (res != undefined) {
          setStatusChage({
            executeChage: true,
            status: true,
            contraseniaInvalid: false,
          });
          getAlert(res.message, process.env.REACT_APP_SERVER_URL_UPNHOSTBASE);
        } else {
          setStatusChage({
            executeChage: true,
            status: false,
            contraseniaInvalid: false,
          });
        }
        setloading(false);
      });
    } else {
      setStatusChage({
        executeChage: false,
        status: false,
        contraseniaInvalid: true,
      });
    }
  };

  useEffect(() => {
    const data = {
      id: id,
    };
    const promiseVT = apiUsers.ValidateToken(data, alertMessage);
    promiseVT.then((res) => {
      if (res != undefined) {
        setUserResponse(res.detail);
        setTokenValid(true);
        setloading(false);
      }
    });
  }, [setUserResponse]);

  return (
    <section className="row" style={{ color: "#ffffff" }}>
      {Loader(Loading)}
      <div id="branding" className="imgBx"></div>
      <div className="contentBx">
        <div className="formBx">
          <img src={Constantes().Imagen.LogoWeb} className="logoBx mb-2"></img>
          <h4 className="mb-5">Recuperé su contraseña </h4>
          {statusChage.executeChage &&
          statusChage.status &&
          !statusChage.contraseniaInvalid ? (
            <label>Cambio de contraseña, se ejecuto correctamente</label>
          ) : statusChage.executeChage &&
            !statusChage.status &&
            !statusChage.contraseniaInvalid ? (
            <label>Error al ejecutar el cambio de contraseña</label>
          ) : null}

          {tokenValid ? (
            <form className="mt-5 col-10 ">
              <div className="form-group">
                <input
                  type="password"
                  className="form-control"
                  placeholder="Nueva contraseña"
                  onChange={handleInputChange}
                  name="contraseniaNueva"
                />
              </div>
              <p></p>
              <div className="form-group">
                <input
                  type="password"
                  className="form-control"
                  placeholder="Confirmar contraseña"
                  onChange={handleInputChange}
                  name="confirmarContraseniaNueva"
                />
              </div>
              <div className="mt-5 form-group d-flex justify-content-end inputBx d-flex justify-content-end">
                {!statusChage.executeChage &&
                !statusChage.status &&
                statusChage.contraseniaInvalid ? (
                  <label>Contraseña ingresada no coinciden</label>
                ) : null}
                <input
                  type="button"
                  className="btnSubmit"
                  value="Guardad Cambios"
                  style={{ width: "100% !important" }}
                  onClick={handleClickSaveNewPassword}
                />
              </div>
            </form>
          ) : (
            <label>Token Expirado, Solicite nuevamente cabiar contraseña</label>
          )}
        </div>
      </div>
    </section>
  );
};
